import axios from 'axios';

/**
 * ThunkAbortController implements nicer API for working with AbortController inside mobx thunks
 */
export class ThunkAbortController {
  private _controller: AbortController | null = null;

  create() {
    this._controller = new AbortController();

    return this._controller;
  }

  remove() {
    this._controller = null;
  }

  abort() {
    this._controller?.abort();
  }

  static isCanceled(value: any) {
    return axios.isCancel(value);
  }
}
